import { useNavigate } from "react-router-dom"
import { Building2 } from "lucide-react"
import { Button } from "@/shared/components/ui/Button"
import { PageLoading } from "@/shared/components/ui/LoadingSpinner"
import { Card } from "@/shared/components/ui/Card"

interface FarmRequiredGuardProps {
  farmId: string | undefined
  isLoading: boolean
  children: React.ReactNode
}

/**
 * Guard component that shows a friendly "Select Farm" prompt when no farm is selected.
 * Use this on high-level pages that require a farm context.
 */
export function FarmRequiredGuard({ farmId, isLoading, children }: FarmRequiredGuardProps) {
  const navigate = useNavigate()

  if (isLoading) {
    return <PageLoading message="Loading farm..." />
  }

  if (!farmId) {
    return (
      <Card>
        <div className="flex flex-col items-center justify-center py-16">
          <div className="w-16 h-16 bg-emerald-50 rounded-xl flex items-center justify-center mb-4 border border-emerald-200/50">
            <Building2 className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="font-roboto text-lg font-semibold text-gray-900 mb-2">Select a Farm</h3>
          <p className="font-roboto text-sm text-gray-600 text-center max-w-sm mb-6">
            Choose a farm to view this feature. All data is organized by farm.
          </p>
          <Button onClick={() => navigate('/farms')}>
            Go to Farms
          </Button>
        </div>
      </Card>
    )
  }

  return <>{children}</>
}

export default FarmRequiredGuard
